import Translation from './index'
import ITranslationKeys from './ITranslationKeys'

export default class EnglishTranslation extends Translation implements ITranslationKeys {
  public 'error.unexpected' = 'Unexpected Error'
  public 'error.404' = 'We couldn\'t find the requested page. We invite you to visit our home page.'
  public 'error.select.min.an.option' = 'Select at least one option'

  public 'user.edit.profile' = 'Edit profile'
  public 'user.close.account' = 'Close account'
  public 'user.manage.billing' = 'Payments & subscriptions'

  public 'profile.documents.title' = 'My documents'
  public 'profile.languages.title' = 'My languages'
  public 'profile.languages.add' = 'Language'
  public 'profile.languages.empty' = 'You haven\'t added any languages yet.'
  public 'profile.languages.level.label' = 'Level'

  public 'profile.cv.latest' = 'Latest CV'
  public 'profile.cv.upgrade.to.analyze' = 'Upgrade to premium to analyze your CV'

  public 'profile.academicTranscript.title' = 'Academic Transcript'
  public 'profile.academicTranscript.latest' = 'Latest academic transcript'

  public 'checkout.already.bought' = 'We have detected that you already have an active subscription'
  public 'checkout.already.bought.explanation' = 'If you want to change it, you can do so in the "Payments & subscriptions" section of your profile.'
  public 'checkout.success' = 'Thanks, payment completed successfully!'

  public 'auth.signup.notAllowed' = 'Sorry, it seems that this email does not have access to Bloom. . If you think this is an error, please contact us at hola@zriveapp.com'
  public 'auth.access.not.active' = 'Your access has expired.'
  public 'auth.access.free.not.active' = 'Sorry but the collaboration period with your university has expired.'
  public 'auth.access.wordpress.not.active' = 'Sorry, it seems that your Zrive account is not active. If you think this is an error, please contact us at hola@zriveapp.com'
  public 'auth.login.or.signup' = 'Login or create your account'
  public 'auth.login.with.another.account' = 'Login with another account'
  public 'auth.account.delete.success' = 'Your account has been deleted'
  public 'auth.account.delete.confirm' = 'Are you sure you want to delete your account? This action cannot be undone.'
  public 'auth.account.delete.confirm.yes' = 'Yes, I want to close my account'
  public 'auth.account.delete.confirm.no' = 'No, I want to keep my account'
  public 'auth.email.mismatch' = 'Emails do not match. Please make sure both emails are the same.'
  public 'auth.email.again' = 'Enter your email again'

  public 'auth.login.username' = 'Email'
  public 'auth.login.password' = 'Password'
  public 'auth.login.signIn' = 'Sign in'
  public 'auth.login.signUp' = 'Sign up'
  public 'auth.login.resetPassword' = 'Reset your password here'
  public 'auth.login.forgotPassword' = 'Forgot your password?'
  public 'auth.login.needVerification' = 'Havent verified your email yet?'
  public 'auth.login.verifyEmail' = 'Verify email'

  public 'auth.signup.signUp' = 'Sign up'
  public 'auth.signup.passwordMismatch' = 'Passwords do not match'
  public 'auth.signup.confirmPassword' = 'Confirm password'
  public 'auth.signup.success' = 'Account created successfully! You will receive an email to activate your account.'

  public 'auth.resetPassword.code' = 'Confirmation code'
  public 'auth.resetPassword.confirm' = 'Confirm'
  public 'auth.resetPassword.submit' = 'Send'
  public 'auth.resetPassword.message' = 'Please check your email for the confirmation code.'
  public 'auth.resetPassword.description' = 'Enter your email to reset your password.'
  public 'auth.confirmResetPassword.description' = 'Confirm your new password.'

  public 'auth.verify.username' = 'Enter your email'
  public 'auth.verify.code' = 'Confirmation code'
  public 'auth.verify.enterCode' = 'Enter the confirmation code'
  public 'auth.verify.verify' = 'Verify'
  public 'auth.verify.resendCode' = 'Resend code'
  public 'auth.verify.codeSent' = 'Code sent. You should receive an email with the confirmation code in a few seconds.'
  public 'auth.verify.codeSent.auto' = 'We have sent you an email with the confirmation code.'
  public 'auth.verify.codeVerified' = 'Email verified successfully!'

  public 'menu.home' = 'Home'
  public 'menu.content' = 'Content'
  public 'menu.logout' = 'Logout'
  public 'menu.cookiePolicy' = 'Cookie Policy'
  public 'menu.privacyPolicy' = 'Privacy Policy'
  public 'menu.hello' = 'Hello'
  public 'menu.profile' = 'Profile'
  public 'menu.my.profile' = 'My profile'
  public 'menu.bookmarks' = 'Bookmarks'
  public 'menu.internalOffersFaqs' = 'Internal Offers FAQs'

  public 'onboarding.title' = 'Welcome to Bloom!'
  public 'onboarding.description' = 'We are looking forward to meeting you...'
  public 'onboarding.personal.title' = 'Personal data'
  public 'onboarding.personal.update.description' = 'Do you want to update your personal data with the ones you registered in Bloom?'
  public 'onboarding.qualificationLevel' = 'What have you studied?'
  public 'onboarding.studies.studying.bachelor' = 'Studying bachelor'
  public 'onboarding.studies.studying.master' = 'Studying master'
  public 'onboarding.studies.graduated' = 'Graduated'
  public 'onboarding.studies.title' = 'Academic background'
  public 'onboarding.studies.description' = 'We need to know some data about your academic background'
  public 'onboarding.studies.academicLevel' = 'What is your current situation?'
  public 'onboarding.working.question' = 'Are you currently working?'
  public 'onboarding.working.employed' = 'Employed'
  public 'onboarding.working.no' = 'Looking for a job'
  public 'onboarding.preferences.title' = 'Preferences and goals'
  public 'onboarding.preferences.description' = 'Tell us about your interests and goals to propose the best content for you'
  public 'onboarding.preferences.knowing.profOps' = 'How familiar are you with the professional opportunities available to you?'
  public 'onboarding.preferences.knowing.goals' = 'How certain are you about the career path you want to follow?'
  public 'onboarding.preferences.which.fav.topics' = 'What categories are you most interested in?'
  public 'onboarding.preferences.which.goals' = 'What are your goals in Bloom?'
  public 'onboarding.preferences.goals.explore.jobs' = 'Explore different job options'
  public 'onboarding.preferences.goals.get.jobs' = 'Get job offers'
  public 'onboarding.preferences.goals.prepare.interviews' = 'Prepare to pass selection processes'
  public 'onboarding.news.title' = 'Shall we start?'
  public 'onboarding.news.description' = 'Do you want us to inform you about what happens in BLOOM?'
  public 'onboarding.news.whatsapp.title' = 'Receive notifications on Whatsapp'
  public 'onboarding.news.whatsapp.description' = 'Whatsapp is the most convenient way to stay informed about everything that happens in the community. We will only send you relevant messages about your interests so you don\'t miss anything.'
  public 'onboarding.news.jobs.title' = 'Receive new job offers by email'
  public 'onboarding.news.jobs.sectors' = 'Tell us which professional careers you are interested in and we will notify you when there are new job offers related to them.'
  public 'onboarding.update' = 'Update my profile'
  public 'onboarding.linkedin' = 'Validate profile'
  public 'onboarding.linkedin.description' = 'To avoid bots and fake profiles, we need to verify your identity with your Linkedin profile.\nThis verification is only done once.'
  public 'onboarding.linkedin.connect' = 'Validate'
  public 'onboarding.linkedin.connected' = 'Linkedin connected!'

  public 'videos.last' = 'Last videos'
  public 'videos.recommended' = 'Recommended videos for you'
  public 'videos.history' = 'Watching history'
  public 'videos.next.playing.in' = 'Playing next video in'

  public 'documents.last' = 'Last documents'
  public 'documents.read' = 'read time'

  public 'common.add' = 'Add'
  public 'common.yes' = 'Yes'
  public 'common.remove' = 'Remove'
  public 'common.no' = 'No'
  public 'common.all' = 'All'
  public 'common.seeAll' = 'See all'
  public 'common.seeMore' = 'See more'
  public 'common.seeDetails' = 'See details'
  public 'common.loadingUser' = 'Loading user'
  public 'common.errorFetchingUser' = 'Error fetching user'
  public 'common.save' = 'Save'
  public 'common.name' = 'Name'
  public 'common.lastName' = 'Last Name'
  public 'common.back' = 'Back'
  public 'common.backTo' = 'Back to'
  public 'common.type' = 'Type'
  public 'common.noResults' = 'No results'
  public 'common.sortBy' = 'Sort by'
  public 'common.sortBy.latest' = 'Latest'
  public 'common.sortBy.title' = 'Title'
  public 'common.sortBy.alphabetically' = 'Alphabetically'
  public 'common.sortBy.recommended' = 'Recommended'
  public 'common.moreInfo' = 'More info'
  public 'common.keepUpToDate' = 'Keep up to date'
  public 'common.continue' = 'Continue'
  public 'common.bachelor' = 'Bachelor'
  public 'common.bachelor.and.master' = 'Bachelor & Master'
  public 'common.bachelor.name' = 'Bachelor name'
  public 'common.bachelor.year.start' = 'Start year of bachelor'
  public 'common.industry' = 'Industry'
  public 'common.industry.sector' = 'Sector'
  public 'common.bachelor.university' = 'University where you study the bachelor'
  public 'common.master.university' = 'University where you study the master'
  public 'common.master.name' = 'Master name'
  public 'common.master.year.end' = 'End year of master'
  public 'common.nothing' = 'Nothing'
  public 'common.nothing.clear' = 'Not clear'
  public 'common.all.clear' = 'Totally clear'
  public 'common.lots' = 'A lot'
  public 'common.phone' = 'Phone'
  public 'common.start.now' = 'Start now'
  public 'common.filter' = 'Filter'
  public 'common.acceptPrivacyPolicy' = 'I have read and accept the'
  public 'common.privacyPolicy' = 'privacy policy'
  public 'common.letsStart' = 'Let\'s start!'
  public 'common.and' = 'and'
  public 'common.daysAgo_1' = '{{days}} day ago'
  public 'common.daysAgo_0' = 'Today'
  public 'common.daysAgo' = '{{days}} days ago'
  public 'common.description' = 'Description'
  public 'common.min.requirements' = 'Minimum Requirements'
  public 'common.cities' = 'Ciudades'
  public 'common.copyLink' = 'Copy Link'
  public 'common.clipboardCopied' = 'Link copied to clipboard'
  public 'common.share' = 'Share'
  public 'common.here' = 'here'
  public 'common.close' = 'Close'
  public 'common.see' = 'See'
  public 'common.characters' = 'characters'
  public 'common.file.select' = 'Select file'
  public 'common.file.change' = 'Change file'
  public 'common.file.exceeds.size' = 'File size exceeds {{size}} limit'
  public 'common.file.noSelected' = 'No file selected'
  public 'common.go.home' = 'Go to home page'
  public 'common.send' = 'Send'
  public 'common.cancel' = 'Cancel'

  public 'content.remove.filters' = 'Remove filters'
  public 'content.see.results' = 'See results'
  public 'content.category' = 'Category'
  public 'content.categories.all' = 'All categories'
  public 'content.sector' = 'Sector'
  public 'content.videos' = 'Videos'
  public 'content.videos.continueWatching' = 'Continue watching'
  public 'content.videoTypes' = 'Session Type'
  public 'content.documents' = 'Documents'
  public 'content.documents.seeFull' = 'See full document'
  public 'content.documentTypes' = 'Type'
  public 'content.result' = 'result'
  public 'content.result_plural' = 'results'
  public 'content.difficultyLevel' = 'Level'
  public 'content.searchByKeyword' = 'Filter by keyword'
  public 'content.moreAuthors' = 'more speakers'
  public 'content.searchDesktop' = 'What do you need? Search videos, documents, companies, events...'
  public 'content.searchMobile' = 'Search videos, documents, companies, events...'
  public 'content.bookmarked.add' = 'Add to bookmarks'
  public 'content.bookmarked.remove' = 'Remove from bookmarks'
  public 'content.bookmarked.success' = 'Saved in your bookmarks'
  public 'content.unbookmarked.success': 'Removed from your bookmarks'
  public 'content.related' = 'Related resources'

  public 'notifications.title' = 'Notifications'
  public 'notifications.noNotifications' = 'There is no notifications at the moment'

  public 'events.title' = 'Events'
  public 'events.next' = 'Next events'
  public 'events.seeAll' = 'See all events'
  public 'events.noEvents' = 'There are no events coming up yet!'
  public 'events.rsvp.attend' = 'I am keen'
  public 'events.rsvp.attending' = 'Attending'
  public 'events.add.to.calendar' = 'Add to my calendar'

  public 'advisor.historic.title' = 'Historic conversations'
  public 'advisor.whatDoYouNeed' = 'What do you need?'
  public 'advisor.question1' = 'What do you I need to take into account when creating my CV?'
  public 'advisor.question2' = 'What are the main job opportunities in Law?'
  public 'advisor.question3' = 'What is the sallary of a strategic consultant?'
  public 'advisor.sources' = 'Sources'
  public 'advisor.notAvailable' = 'ZriveGPT is not available right now'
  public 'advisor.newConversation' = 'New chat'

  public 'companies.title' = 'Companies'
  public 'companies.description' = 'Explore the best companies in the sectors you are interested in.'
  public 'companies.culture.title' = '¿What makes us different?'
  public 'companies.work.title' = 'Work in {{companyName}}'
  public 'companies.work.officesIn' = 'Office in {{cities}}'
  public 'companies.work.officesIn_one' = 'Office in {{cities}}'
  public 'companies.work.officesIn_other' = 'Offices in {{cities}}'
  public 'companies.contact.title' = 'Do you have questions?'
  public 'companies.contact.followUs' = 'Follow {{companyName}}:'
  public 'companies.applicants.profile' = 'Candidates\' Profile'
  public 'companies.position.details' = 'Position details'
  public 'companies.process.selection' = 'Selection process'
  public 'companies.interview.get' = 'Get the interview'
  public 'companies.interview.pass' = 'Pass the interviews'
  public 'companies.interview.take.account' = 'Application recommendations'
  public 'companies.interview.doc.types' = 'What documents do you need?'
  public 'companies.interview.cv.valoration' = 'How the CV is evaluated'
  public 'companies.interview.process.works' = 'How the selection process works'
  public 'companies.interview.resources.links' = 'Resources for preparation'
  public 'companies.interview.skills.tested' = 'Skills tested in the interview'

  public 'cv' = 'Curriculum Vitae'
  public 'cv.uploaded' = 'New CV uploaded'
  public 'cv.analysis.new' = 'Analyse a new CV'
  public 'cv.analysis.results' = 'CV Analysis'
  public 'cv.analysis.results.for.offer' = 'CV compatibility'
  public 'cv.analysis.resources' = 'Resources'
  public 'cv.analysis.resources.video' = 'You can watch this <1>video</1> where we explain all the keys to a great CV.'
  public 'cv.analysis.resources.document' = 'In this <1>document</1>, you\'ll find the main sections companies pay attention to.'
  public 'cv.analysis.resources.templates' = 'We recommend using this <1>template</1>, which has been validated by Zrive.'
  public 'cv.quality.excellent' = 'Excellent'
  public 'cv.quality.good' = 'Good'
  public 'cv.quality.needs.improvement' = 'Needs Improvement'
  public 'cv.points.improvement' = 'Points for Improvement'
  public 'cv.points.offer.requirements' = 'Requirements missing in the CV'
  public 'cv.no.improvement.points' = 'No improvement points were identified.'
  public 'cv.upload.title' = 'Analyze your CV with AI'
  public 'cv.upload.description' = 'Only PDF files are accepted, as this is the format that should always be sent to companies.'
  public 'cv.upload.select' = 'Add CV'
  public 'cv.upload.change' = 'Change File'
  public 'academic.transcript.title' = 'Academic Transcript'
  public 'academic.transcript.upload.select' = 'Add Academic Transcript'
  public 'academic.transcript.upload.change' = 'Change File'
  public 'jobs.apply.coverLetter.title' = 'Cover Letter'
  public 'jobs.apply.coverLetter.upload.select' = 'Add Cover Letter'
  public 'jobs.apply.coverLetter.upload.change' = 'Change File'
  public 'jobs.apply.languages.title' = 'Language levels'
  public 'jobs.apply.languages.selectLevel' = 'Select your level'
  public 'academic.transcript.latest.used' = 'Your latest academic transcript will be used'
  public 'academic.transcript.uploaded' = 'New academic transcript uploaded'
  public 'academic.transcript.upload.processing' = 'Uploading...'
  public 'cv.upload.analyzing' = 'Analyzing...'
  public 'cv.upload.analyze' = 'Analyze CV'
  public 'cv.upload.loadingMessages.processing' = 'We are processing your CV'
  public 'cv.upload.loadingMessages.checkingFormat' = 'Checking that the format is correct'
  public 'cv.upload.loadingMessages.analyzingStructure' = 'Analyzing the content structure'
  public 'cv.upload.loadingMessages.checkingConsistency' = 'Checking consistency and style'
  public 'cv.upload.loadingMessages.takingTime' = 'This will take a little time'
  public 'cv.upload.loadingMessages.stillWorking' = 'We are still working on it'
  public 'cv.upload.loadingMessages.almostThere' = 'Almost there'
  public 'cv.upload.loadingMessages.finalTouches' = 'Adding the final touches'
  public 'cv.page.title' = 'CV Roaster'
  public 'cv.page.description' = 'Improve your CV with our AI, which analyzes and evaluates it based on Zrive\'s knowledge of how to create strong CVs for junior profiles.'
  public 'ai.disclaimer' = 'This tool is designed to serve as guidance, as although it has been rigorously tested, it uses AI models that, by their nature, may generate inaccuracies.'
  public 'cv.error.selectFile' = 'Please select a CV file to upload'
  public 'cv.error.analysisFailed' = 'Failed to analyze CV'
  public 'cv.save.new.version' = 'Save CV version'

  public 'ai.user.feedback.saved' = 'Thank you for your feedback!'
  public 'ai.user.positive.feedback.placeholder' = 'Tell us what worked for you'
  public 'ai.user.negative.feedback.placeholder' = 'Desccribe what didn\'t work as you expected'
  public 'interviewer.ai.title' = 'Select an interview before assessing your knowledge'
  public 'interviewer.ai.description' = 'The test consists of {{amount}} main questions with possible follow-up questions to explore your answers in more depth. The test takes approximately {{expectedTime}} to complete.'
  public 'interviewer.ai.description_singular' = 'The test consists of {{amount}} question with possible follow-up questions to explore your answers in more depth. The test takes approximately {{expectedTime}} to complete.'
  public 'interviewer.ai.progress' = 'In progress'
  public 'interviewer.ai.start' = 'Start Interview'
  public 'interviewer.ai.start.new' = 'Start New Interview'
  public 'interviewer.ai.continue' = 'Continue Interview'
  public 'interviewer.ai.new' = 'New Interview'
  public 'interviewer.ai.completed' = 'Interview Completed!'
  public 'interviewer.ai.passed' = 'Passed'
  public 'interviewer.ai.failed' = 'Needs Improvement'
  public 'interviewer.ai.result' = 'Result'
  public 'interviewer.ai.dataScience.result.disclaimer' = '<b>Note:</b> This test is only an assessment of technical skills. Actual data science interviews often also assess:<ul class="list-disc pl-4 md:pl-5"><li>Business case analysis</li><li>System design and architecture</li><li>Soft skills and cultural fit</li></ul>'
  public 'interviewer.ai.behavioural.resources.title' = 'Resources'
  public 'interviewer.ai.behavioural.resources.video' = 'You can watch this <1>video</1> where we explain how to prepare for a FIT interview.'
  public 'interviewer.ai.behavioural.resources.document' = 'In this <1>document</1> you can find a guide on how to use the STAR method to answer personal FIT questions.'
  public 'interviewer.ai.behavioural.resources.summary' = 'For this type of questions, the best is to use the STAR method, to ensure that your answer is coherent, logical and ordered.'
  public 'interviewer.ai.custom.resources.title' = 'How does it work?'
  public 'interviewer.ai.custom.resources.summary' = 'This tool generates interviews tailored to the job description so you can practice and improve your answers.'
  public 'interviewer.ai.loadingMessages.asking.0' = 'We are processing your answer'
  public 'interviewer.ai.loadingMessages.asking.1' = 'Evaluating the answer'
  public 'interviewer.ai.loadingMessages.asking.2' = 'It will take a moment'
  public 'interviewer.ai.loadingMessages.asking.3' = 'Deciding the next action'
  public 'interviewer.ai.loadingMessages.asking.4' = 'We are almost there'
  public 'interviewer.ai.loadingMessages.default.0' = 'Getting everything ready...'
  public 'interviewer.ai.loadingMessages.default.1' = 'One moment please...'
  public 'interviewer.ai.loadingMessages.evaluating.0' = 'Evaluating the interview'
  public 'interviewer.ai.loadingMessages.evaluating.1' = 'Processing all answers'
  public 'interviewer.ai.loadingMessages.evaluating.2' = 'Assessing the quality and depth of the answers'
  public 'interviewer.ai.loadingMessages.evaluating.3' = 'Still working on it'
  public 'interviewer.ai.loadingMessages.evaluating.4' = 'Writing the feedback'
  public 'interviewer.ai.loadingMessages.evaluating.5' = 'Deciding the outcome'
  public 'interviewer.ai.loadingMessages.evaluating.6' = 'Almost there'

  public 'interviewer.ai.topic.custom-interview.description' = 'A personalized interview for a specific job offer'
  public 'interviewer.ai.topic.custom-interview.add.job.description' = 'Add the job offer description here...'
  public 'interviewer.ai.job.description.required' = 'Please add the job offer description'
  public 'interviewer.ai.topic.behavioural.description' = 'Behavioural interview about past situations (STAR method)'
  public 'interviewer.ai.topic.fit-interview.description' = 'Practice how to talk about yourself and your experience'
  public 'interviewer.ai.topic.data-science.description' = 'Technical interview about Data Science and Machine Learning'
  public 'interviewer.ai.jobDescription.error.message' = 'There\'s an issue with the job description, and we\'re unable to generate the interview. Please contact us at hola@zriveapp.com to resolve it.'

  public 'jobs.last' = 'Last jobs'
  public 'jobs.internship' = 'Internships'
  public 'jobs.recruiting.event' = 'Event'
  public 'jobs.invitation.recruiting.event' = 'Event invitation'
  public 'jobs.workShift' = 'Work shift'
  public 'jobs.unlimited' = 'Unlimited'
  public 'jobs.title' = 'Jobs'
  public 'jobs.description' = 'We have filtered the best job offers for junior profiles in Spain so you don\'t have to do it.'
  public 'jobs.internship.curriculars' = 'Curriculars internships'
  public 'jobs.internship.agreement' = 'With internship agreement'
  public 'jobs.see.offer' = 'See job'
  public 'jobs.apply.offer' = 'Enter to the offer'
  public 'jobs.see.internal' = 'BLOOM offers'
  public 'jobs.apply.offer.now' = 'Apply now'
  public 'jobs.apply.latest.cv.used' = 'Your latest CV will be used'
  public 'jobs.apply.description' = 'At BLOOM we are collaborating with {{company}} to help them find the best young talent. \n If you are interested in this position, please complete this form so we can consider your application'
  public 'jobs.application.sent' = 'Application sent'
  public 'jobs.apply.success' = 'Your application has been sent to the company.'
  public 'jobs.apply.success.description' = 'If your profile is a good fit, they may contact you in the coming days. In the meantime, you can keep improving your application by preparing for the interview with our tools.'
  public 'jobs.apply.profContext.label' = 'Context about your current professional situation'
  public 'jobs.apply.profContext.placeholder' = 'Indicate your current professional situation along with your expectations for this job offer.'
  public 'jobs.apply.confirmWorkShift' = 'Confirm that you will be able to work under {{workShiftLabel}}'
  public 'jobs.apply.confirmLocation' = 'Confirm that you will be able to work in {{countryName}}'
  public 'jobs.apply.canSignInternshipAgreement.label' = 'Can you sign an internship agreement?'
  public 'jobs.prepare.for.interview' = 'Prepare interviews'
  public 'jobs.prepare.interview' = 'Prepare interview'
  public 'jobs.prepare.interview.fit' = 'Train soft-skills (FIT)'
  public 'jobs.prepare.interview.behavioural' = 'Train soft-skills (behavioural)'
  public 'jobs.have.applied' = 'You have applied'
  public 'jobs.have.engaged' = 'Preparing application'
  public 'jobs.see.applied' = 'See applied'
  public 'jobs.contract.type' = 'Contract type'
  public 'jobs.contract.details' = 'Contract details'
  public 'jobs.apply.date.limit' = 'Application deadline'
  public 'jobs.contact.person' = 'Contact person'
  public 'jobs.process.train' = 'Get ready for the interview'
  public 'jobs.process.info' = 'Check the selection process'
  public 'jobs.enableAlerts' = 'Enable alerts'
  public 'jobs.dontMissOffers' = 'to not miss any offers'
  public 'jobs.internal' = 'Bloom offer'
  public 'jobs.improve.candidate.title' = 'Improve my profile as a candidate'
  public 'jobs.improve.candidate.subTitle' = 'Adapt your profile'
  public 'jobs.improve.candidate.description' = 'We help you improve your profile to maximize your chances of getting the job.'
  public 'jobs.improve.candidate.adapt.cv' = 'Adapt CV'
  public 'jobs.match.level.cv' = 'Compatibility of your CV'
  public 'jobs.info.profile.with.ai' = 'You can either apply directly or tailor your profile to the job offer with the help of our AI.'

  public 'courses.title' = 'Courses'
  public 'courses.document' = 'Document'
  public 'courses.class' = 'Class'
  public 'courses.supportMaterial' = 'Support material'
  public 'courses.completed.video' = 'Completed!'
  public 'courses.completed.section' = 'Unit completed!'
  public 'course.authors.title' = 'Meet your professors'
  public 'course.start' = 'Start course'
  public 'course.continue' = 'Continue course'
  public 'course.nextPromotion' = 'Upcoming promotion'

  public 'studioAi.home.title' = 'Improve your profile as a candidate'
  public 'studioAi.home.subtitle' = 'Prepare a professional CV, practice real interviews, and solve your doubts about professional careers. Become a better candidate.'
  public 'studioAi.home.cvRoaster' = 'Optimize your CV'
  public 'studioAi.home.aiInterview' = 'Practice interviews'
  public 'studioAi.home.advisorAi' = 'Solve your doubts'
  public 'studioAi.home.cvRoaster.subtitle' = 'Optimize your CV and avoid being rejected'
  public 'studioAi.home.cvRoaster.job.feedback' = 'Feedback adapted to job offer'
  public 'studioAi.home.cvRoaster.job.new' = 'New version'
  public 'studioAi.home.aiInterview.subtitle' = 'Simulate interviews to be better prepared'
  public 'studioAi.home.aiInterview.job.header' = 'Adapted interview to job offer'
  public 'studioAi.home.advisorAi.subtitle' = 'Explore all the knowledge of BLOOM with our AI'

  public 'premium.banner.description' = 'Unlimited access to the most advanced tools to improve your profile and make it stand out from other candidates.'
  public 'premium.cta.button' = 'Join now'

  public 'zriveReferralProgram.title' = 'Recommend Zrive to your friends'
  public 'zriveReferralProgram.youGet' = 'You get'
  public 'zriveReferralProgram.theyGet' = 'They get'
  public 'zriveReferralProgram.theyGet.description1' = '<0>5% Off</0> in the Zrive course'
  public 'zriveReferralProgram.description1' = '<0>90 days of Bloom Pro for FREE</0> for each friend who signs up to Zrive'
  public 'zriveReferralProgram.description2' = '100€ Amazon voucher when <0>3 friends</0> sign up to Zrive'
  public 'zriveReferralProgram.friendName' = 'Your Friend\'s name'
  public 'zriveReferralProgram.friendEmail' = 'Your Friend\'s email'
  public 'zriveReferralProgram.program' = 'Zrive program'
  public 'zriveReferralProgram.submit' = 'Send invitation'
  public 'zriveReferralProgram.success' = 'Invitation sent! Your friend will receive an email.'
  public 'zriveReferralProgram.sendAnother' = 'Send another invitation'
  public 'zriveReferralProgram.validation.required' = 'Email and program are required.'
  public 'zriveReferralProgram.referralsCompleted' = 'Friends who joined Zrive'
  public 'zriveReferralProgram.inviteSectionTitle' = 'Invite a friend'
  public 'zriveReferralProgram.myRewards' = 'My Rewards'
  public 'zriveReferralProgram.claim' = 'Claim'
  public 'zriveReferralProgram.claimed' = 'Claimed'
  public 'zriveReferralProgram.claimSuccessBloom' = 'You have successfully claimed this reward'
  public 'zriveReferralProgram.claimSuccessAmazon' = 'We will send you the reward to your email soon'
  public 'zriveReferralProgram.noRewardsYet' = 'No rewards yet. They will appear here when you have any to claim or have already claimed.'
  public 'zriveReferralProgram.referralsNeeded' = '{{count}} more friend needed'
  public 'zriveReferralProgram.programNotPartOfReferral' = 'We\'d love you refer your friend, bear in mind for the program you selected there are no rewards. For more info see the terms and conditions.'
  public 'zriveReferralProgram.bannerUnclaimedMessage' = 'You have rewards to claim'
  public 'zriveReferralProgram.bannerUnclaimedLink' = 'Claim your rewards'

  public 'upgradePro.title' = 'You have exceeded the limit of free uses'
  public 'upgradePro.subtitle' = 'Join BLOOM PRO to keep improving your profile'
  public 'upgradePro.benefitsHeader' = 'With BLOOM PRO you get:'
  public 'upgradePro.benefit1' = 'Unlimited use of all our AI tools trained to help you improve your CV, adapt it to job offers, and prepare for interviews.'
  public 'upgradePro.benefit2' = 'BLOOM Recommendations. We work with companies that trust BLOOM to find the best talent. The more you prepare and the better we know you, the more we can recommend you.'
  public 'upgradePro.cta' = 'Upgrade to PRO'

  public 'speech.to.text.disclaimer' = 'Answering with audio is a BETA feature. It is recommended to use Google Chrome and ensure there is no background noise to maximize audio quality.'
}
